import { VDP_LINK_COUNT } from '~/constants/home';
import { VdpCardType } from '~/constants/home/VdpCardType';

// Recently viewed already in the link card moves Suggested first; suggested in the link card skips those 3.
export default function getTopCarouselsLayout(cardType: VdpCardType) {
  const isSuggestedInVdpLinks = cardType === VdpCardType.Suggested;

  return {
    isSuggestedFirst: cardType === VdpCardType.Recent,
    suggested: {
      skip: isSuggestedInVdpLinks ? VDP_LINK_COUNT : 0,
      title: isSuggestedInVdpLinks
        ? 'More suggested vehicles'
        : 'Suggested for you'
    }
  };
}
